import { render, staticRenderFns } from "./recipient-verification.vue?vue&type=template&id=7bbae759&scoped=true&"
import script from "./recipient-verification.vue?vue&type=script&lang=js&"
export * from "./recipient-verification.vue?vue&type=script&lang=js&"
import style0 from "./recipient-verification.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./recipient-verification.vue?vue&type=style&index=1&id=7bbae759&scoped=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "7bbae759",
  null
  
)

export default component.exports